 function getClassToImageName (class_num) {
  switch(Number(class_num)) {
    case 1:
      return 'm_brawl'
    case 64:
      return 'f_brawler'
    case 2:
      return 'm_sword'
    case 128:
      return 'f_swords'
    case 4:
      return 'f_archer'
    case 256:
      return 'm_archer'
    case 8:
      return 'f_shaman'
    case 512:
      return 'm_shaman'
    case 1024:
      return 'm_gunner'
    case 2048:
      return 'f_gunner'
    case 16:
      return 'm_extreme'
    case 32:
      return 'f_extreme'
    case 4096:
      return 'm_assassin'
    case 8192:
      return 'f_assassin'
  }
}

function getClassToNumber (className) {
  switch(Number(className)) {
    case 'brawler':
      return 1;
    case 'swordman':
      return 2;
    case 'archer':
      return 4;
    case 'shaman': 
      return 8;
    case 'gunner':
      return 1024;
    case 'extreme':
      return 16;
    case 'assassin':
      return 4096;
  }
}

function getItemShopTabs () {
  return [
    {
      label: 'All',
      value: -1
    },
    {
      label: 'Misc. Item',
      value: 0
    },
    {
      label: 'Characters',
      value: 1
    },
    {
      label: 'Pet Items',
      value: 2
    },
    {
      label: 'Weapons',
      value: 3
    },
    {
      label: 'Costumes',
      value: 4
    },
    {
      label: 'Headgears',
      value: 5
    },
    {
      label: 'Accessories',
      value: 6
    },
    {
      label: 'Footwears',
      value: 7
    },
    {
      label: 'Wheels',
      value: 8
    },
    {
      label: 'Destiny Boxes',
      value: 9
    }
  ]
}

function getUserLevel () {
    return [
      {
        label: 'User Common',
        value: '0'
      },
      {
        label: 'User MidMan',
        value: '2'
      },
      {
        label: 'User Streamer',
        value: '3'
      },
      {
        label: 'Ticket Processor',
        value: '19'
      },
      {
        label: 'User Admin',
        value: '32'
      }
    ]
}

export default {
	getClassToImageName,
  getClassToNumber,
  getItemShopTabs,
  getUserLevel
};